import { render, staticRenderFns } from "./screenshots.vue?vue&type=template&id=2f75cd4e&"
import script from "./screenshots.vue?vue&type=script&lang=js&"
export * from "./screenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports